import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Código'},
    {title: 'Nombre'},
];


class MonedaModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }

    closeCurrencies = async () => {
        $('#currenciesModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#currenciesModal').on('hidden.bs.modal', function () {
            //console.log("cerrar currenciesModal");
            cleanData();
        });
    };

    render() {
        const {data, selectCurrency} = this.props;
        //console.log("data Almacen", data);

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="currenciesModal"></div>;
        }

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="currenciesModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de Monedas</h4>
                                <button type="button" className="close" onClick={this.closeCurrencies} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" > 
                                                <table className="table response" style={{marginBottom: 0, height: 570, maxHeight: 570}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"currenciesModal"} action={selectCurrency}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeCurrencies}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MonedaModal;